import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faNewspaper } from '@fortawesome/free-solid-svg-icons';
import '../css/components/NewsletterLogo.css';

interface NewsletterLogoProps {
    domain?: string;
    size?: number;
}

// Sponsored-newsletter placements have no domain field in the data model, so
// there's usually no real favicon to show (see guessNewsletterDomain — it's a
// best-effort guess, not authoritative). Rather than fall back to
// CompanyLogo's plain initial-letter badge, which reads as "broken" for
// something that isn't a company, this shows an explicit newsletter glyph so
// the placeholder looks intentional instead of like a missing image.
const NewsletterLogo: React.FC<NewsletterLogoProps> = ({ domain, size = 32 }) => {
    const [failed, setFailed] = useState(false);
    const cleanDomain = (domain || '').trim().toLowerCase();

    if (!cleanDomain || failed) {
        return (
            <span
                className="newsletter-logo newsletter-logo--fallback"
                style={{ width: size, height: size, fontSize: size * 0.42 }}
                aria-hidden="true"
            >
                <FontAwesomeIcon icon={faNewspaper} />
            </span>
        );
    }

    return (
        <img
            className="newsletter-logo"
            style={{ width: size, height: size }}
            src={`https://www.google.com/s2/favicons?domain=${cleanDomain}&sz=${size * 2}`}
            alt=""
            aria-hidden="true"
            loading="lazy"
            onError={() => setFailed(true)}
        />
    );
};

export default NewsletterLogo;
